var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWalletDivider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 24,
    viewBox: "0 0 396 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_6813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.742 8.73068C134.586 8.61862 108.983 8.73068 84.2332 8.84273C57.3791 8.96497 29.8335 9.08721 2.36919 8.91404C1.58624 8.53713 0.793118 8.17041 0 7.80368C28.2371 7.99723 56.5859 7.87499 84.2129 7.75275C108.972 7.6407 134.576 7.52864 159.742 7.6407C160.23 7.6407 160.627 7.88518 160.627 8.19078C160.627 8.4862 160.22 8.73068 159.732 8.73068H159.742Z",
    fill: "url(#paint0_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.868 8.66974C385.862 8.71049 375.826 8.75124 366.034 8.80217C352.775 8.86329 339.068 8.9346 325.585 8.96516C301.639 9.02628 254.266 9.02628 229.079 8.75124C228.591 8.75124 228.194 8.49657 228.205 8.19096C228.205 7.89555 228.611 7.65107 229.099 7.65107H229.12C254.296 7.92611 301.649 7.92611 325.585 7.86499C339.068 7.83443 352.775 7.76312 366.024 7.702C375.857 7.65107 385.944 7.60013 396 7.56957C395.949 7.9363 395.908 8.29283 395.868 8.65955V8.66974Z",
    fill: "url(#paint1_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.045 18.0204C200.822 18.0611 199.256 18.7131 198.381 19.2937C196.47 20.6587 194.721 24 194.629 24C194.548 24 192.819 20.6587 190.908 19.2835C190.033 18.7131 188.457 18.0407 188.233 18.0102C192.097 18.5195 194.578 13.7419 194.66 13.7419C194.741 13.7419 197.588 18.5806 201.035 18.0102L201.045 18.0204Z",
    fill: "url(#paint2_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.363 19.6812C157.241 19.5794 157.139 19.4775 157.058 19.3756C156.082 18.1736 156.316 16.9002 157.18 15.7695C157.363 15.4232 157.658 15.0666 158.085 14.7203C158.837 14.1193 159.925 13.5182 161.166 13.0191C161.481 12.8765 161.796 12.7542 162.122 12.632C161.328 12.7033 160.576 12.8052 159.854 12.9681C159.539 13.0802 159.244 13.1923 158.959 13.3145C158.929 13.3451 158.888 13.3756 158.827 13.396C158.786 13.4062 158.756 13.4164 158.715 13.4367C158.461 13.559 158.217 13.7016 157.993 13.8442C156.6 14.761 155.238 16.0344 155.299 17.3281C155.339 18.2653 156.183 19.0802 157.343 19.6914L157.363 19.6812ZM153.509 17.2364C153.753 16.3705 154.638 15.6473 155.502 14.9444C155.899 14.6286 156.285 14.2822 156.712 13.9766C156.153 14.1906 155.594 14.4045 155.075 14.6591C154.017 15.1787 152.258 16.3705 153.509 17.2364ZM160.901 12.0412C160.739 12.0513 160.576 12.0717 160.413 12.0921C159.091 12.2449 157.79 12.4894 156.631 12.9274C155.838 13.2228 154.16 14.0479 154.018 14.7305C154.333 14.5471 154.668 14.3739 155.024 14.2109C156.641 13.4775 158.258 12.8867 160.037 12.5403C160.84 12.2958 161.715 12.1125 162.62 11.9698C162.101 11.9698 161.572 11.9902 161.044 12.031C160.993 12.0412 160.942 12.0513 160.891 12.0412H160.901Z",
    fill: "url(#paint3_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.698 8.23088C163.647 8.6791 162.579 9.34124 162.966 9.82002C163.047 9.64684 163.077 9.46348 163.24 9.29031C163.433 9.07638 163.647 8.90321 163.992 8.78097C164.613 8.55686 165.701 8.4448 166.341 8.65873C166.443 8.68929 166.463 8.76059 166.372 8.81153C165.853 9.10694 165.619 9.35143 165.64 9.78946C165.65 10.2071 165.935 10.5433 166.321 10.8693C166.962 11.4092 167.999 11.9694 169.005 12.2445C170.002 12.5195 171.11 12.7538 172.198 12.7844C172.941 12.8047 173.693 12.6723 174.415 12.8251C174.527 12.8455 174.527 12.9372 174.445 12.9779C174.415 12.9983 174.374 13.0187 174.344 13.039C174.293 13.0696 174.242 13.0594 174.201 13.039C173.805 13.2122 173.083 13.202 172.656 13.2428C171.751 13.3243 170.826 13.2631 169.931 13.1816C167.948 12.9779 166.118 12.4075 164.328 11.8777C163.393 11.6027 162.386 11.3277 161.359 11.2563C160.373 11.185 159.427 11.0322 158.43 11.0017C157.383 10.9711 156.265 10.9406 155.228 11.0221C154.079 11.1239 153.184 11.348 152.289 11.7962C152.208 11.837 152.065 11.7962 152.055 11.7351C152.045 11.4601 152.38 11.2258 152.635 11.0221C153.052 10.6859 153.54 10.4108 154.089 10.146C155.177 9.62647 156.234 9.20881 157.617 9.08657C158.166 9.03564 158.715 8.99489 159.274 9.03564C159.62 9.0662 159.864 9.17825 160.108 9.02545C160.301 8.90321 160.23 8.73003 160.24 8.55686C160.261 8.00677 160.271 7.5993 159.712 7.1409C159.295 6.80474 158.847 6.50932 158.39 6.19353C158.329 6.15278 158.359 6.07129 158.451 6.0611C159.01 5.94905 159.885 6.23428 160.393 6.34633C161.237 6.53988 162.132 6.78436 162.813 7.15108C163.321 7.42613 163.769 7.80304 163.718 8.23088H163.698Z",
    fill: "url(#paint4_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.582 6.72276C193.47 7.06911 192.677 7.05892 192.545 6.74313C191.752 6.97743 191.02 7.50714 190.501 7.85349C189.738 8.35264 189.26 9.05553 189.423 9.75842C189.576 10.4002 190.287 11.0725 191.091 11.4902C191.579 11.7448 192.057 11.8671 192.697 11.8569C193.002 11.8569 193.836 11.8365 194.182 11.6735C193.836 11.6532 193.765 11.4087 194.06 11.1846C194.558 10.8077 195.382 10.9706 195.738 11.3679C196.205 11.8874 195.941 12.6311 195.3 13.0487C195.127 13.1608 194.924 13.2525 194.69 13.334C194.009 13.7516 193.053 14.047 192.097 14.0369C190.735 14.0369 189.565 13.5173 188.803 12.8552C187.949 12.1116 187.471 11.3374 187.532 10.4307C187.593 9.38151 188.315 8.58694 189.128 7.6905C189.179 7.63957 189.271 7.62938 189.342 7.64976C189.871 7.12005 190.582 6.49865 191.528 6.31529C191.986 6.22361 193.765 6.21342 193.592 6.73295L193.582 6.72276ZM188.559 12.2542C189.24 13.008 190.226 13.6905 191.691 13.8229C192.402 13.8841 193.135 13.772 193.755 13.5479C193.246 13.6294 192.718 13.6498 192.27 13.5886C189.535 13.2117 188.457 11.4392 188.254 9.89084C188.203 9.54449 188.254 9.21852 188.386 8.90273C188.162 9.20833 187.979 9.51393 187.898 9.8501C187.695 10.716 187.867 11.48 188.559 12.244V12.2542Z",
    fill: "url(#paint5_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.988 4.37913C196.988 4.37913 195.117 2.23991 193.592 3.68643C192.189 5.0209 192.077 6.20256 186.566 9.64569C186.668 9.64569 186.759 9.71699 186.678 9.7883C186.281 10.1041 185.966 10.4097 185.63 10.756C185.366 11.0311 185.03 11.2756 184.603 11.4589C183.729 11.846 182.661 12.1516 181.675 12.4063C179.712 12.9258 177.659 13.1601 175.533 13.0684C173.276 12.9768 171.202 12.3146 169.524 11.408C168.629 10.9292 167.816 10.3893 167.185 9.77811C166.982 9.57438 166.626 9.28915 166.779 9.05485C166.606 8.84093 166.463 8.62701 166.382 8.4029C166.118 7.64908 166.331 6.88508 166.86 6.20256C167.002 5.95808 167.206 5.72378 167.501 5.49968C167.633 5.39781 167.775 5.30613 167.907 5.21445C168.019 5.13295 168.141 5.05146 168.263 4.98015C168.294 4.95978 168.324 4.95978 168.355 4.95978C171.029 3.554 174.801 3.76793 175.503 5.23482C176.276 6.8647 173.479 7.44535 172.412 6.56928C172.412 6.56928 171.791 6.33499 172.117 5.93771C172.442 5.53024 170.937 5.49968 170.388 6.24331C169.839 6.98694 168.721 8.67794 174.7 10.1245C181.055 11.6627 188.172 10.6236 191.182 3.16691C194.182 -4.2898 200.018 3.61512 196.998 4.37913H196.988ZM174.069 12.172C173.815 12.1924 169.839 11.6321 167.755 9.98185C167.541 9.80867 167.328 9.62531 167.124 9.44195C167.399 9.80867 168.131 10.3078 168.294 10.4199C169.016 10.9292 169.849 11.408 170.754 11.7951C172.473 12.5285 174.252 12.9156 176.347 12.9258C178.319 12.936 180.19 12.6508 181.98 12.1414C182.865 11.8868 183.871 11.6219 184.624 11.2348C185.102 10.9903 185.386 10.6644 185.671 10.3384C185.824 10.1652 186.007 10.0226 186.2 9.87998C185.834 10.0939 185.458 10.3078 185.051 10.5217C181.217 12.5184 177.211 12.6508 174.059 12.1822L174.069 12.172Z",
    fill: "url(#paint6_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.372 8.23112C189.22 8.22093 189.067 8.2413 188.925 8.30242C188.925 8.31261 188.905 8.33298 188.884 8.34317C188.813 8.37373 188.742 8.40429 188.671 8.42466C188.284 8.64877 187.979 9.02568 187.806 9.22942C187.461 9.6267 187.084 10.0545 187.074 10.5028C187.054 10.951 187.176 11.4603 187.45 11.8882C187.674 12.2447 188.305 12.6725 188.955 12.754C188.996 12.8355 189.057 12.9068 189.138 12.968C188.244 13.08 187.379 13.0087 186.698 12.6012C186.088 12.2243 185.844 11.6946 185.925 11.1751C186.017 10.5741 186.149 9.88137 186.688 9.35166C186.962 9.07662 187.318 8.84232 187.705 8.6284C187.918 8.50616 188.152 8.42466 188.376 8.34317C188.65 8.14962 188.986 8.00701 189.403 8.04775C189.596 8.06813 189.565 8.25149 189.362 8.2413L189.372 8.23112Z",
    fill: "url(#paint7_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.508 10.1866C191.752 10.2681 191.965 10.4311 192.077 10.5533C192.463 10.9913 192.169 11.3377 191.67 11.684C191.691 11.7044 191.691 11.735 191.65 11.7655C191.426 11.9285 190.633 11.9387 190.745 11.6433C190.765 11.5923 190.877 11.5414 190.928 11.5007C191.04 11.4294 191.131 11.3377 191.233 11.2562C191.487 11.0015 191.701 10.6144 191.396 10.3801C191.365 10.3597 191.335 10.3394 191.294 10.319C191.569 10.6144 191.467 11.0423 190.786 11.0626C189.738 11.1034 189.433 10.3394 189.189 9.87078C189.128 9.75873 189.403 9.68742 189.464 9.79948C189.555 9.97265 189.626 10.1662 189.759 10.3292C189.871 10.5329 190.094 10.6959 190.409 10.8182C191.081 10.6348 191.243 10.4616 190.898 10.2986C190.816 10.2477 190.887 10.1866 190.959 10.156C191.091 10.1051 191.233 10.1153 191.375 10.1356C191.406 10.1356 191.447 10.1356 191.477 10.156C191.477 10.156 191.497 10.156 191.508 10.1662V10.1866Z",
    fill: "url(#paint8_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.637 11.6229C160.637 11.6229 154.882 10.9404 152.98 12.3258C151.079 13.7112 152.513 14.1594 152.95 13.8029C153.387 13.4565 154.983 11.4293 160.627 11.6127L160.637 11.6229Z",
    fill: "url(#paint9_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.356 17.3285C234.417 16.0348 233.055 14.7614 231.662 13.8446C231.438 13.702 231.204 13.5696 230.94 13.4372C230.899 13.427 230.869 13.4066 230.828 13.3964C230.767 13.376 230.726 13.3455 230.696 13.3149C230.421 13.1825 230.116 13.0704 229.801 12.9686C229.069 12.8056 228.327 12.6935 227.534 12.6324C227.859 12.7546 228.174 12.8871 228.489 13.0195C229.74 13.5187 230.828 14.1197 231.57 14.7207C231.997 15.067 232.302 15.4134 232.475 15.7699C233.35 16.9007 233.573 18.1842 232.597 19.376C232.516 19.4779 232.414 19.5798 232.292 19.6816C233.451 19.0704 234.295 18.2555 234.336 17.3183L234.356 17.3285ZM234.59 14.6698C234.082 14.4151 233.523 14.2012 232.953 13.9872C233.38 14.303 233.767 14.6392 234.163 14.955C235.027 15.6579 235.912 16.3811 236.156 17.247C237.407 16.3811 235.648 15.1893 234.59 14.6698ZM228.611 12.0314C228.083 11.9906 227.554 11.9703 227.035 11.9703C227.94 12.1129 228.815 12.2962 229.618 12.5407C231.397 12.8871 233.014 13.4779 234.631 14.2114C234.987 14.3743 235.322 14.5475 235.638 14.7309C235.505 14.0484 233.817 13.213 233.024 12.9278C231.865 12.5 230.564 12.2453 229.242 12.0925C229.079 12.0721 228.916 12.0619 228.754 12.0416C228.703 12.0416 228.652 12.0416 228.601 12.0314H228.611Z",
    fill: "url(#paint10_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.883 7.15069C227.564 6.78397 228.459 6.53948 229.303 6.34594C229.811 6.22369 230.686 5.94865 231.245 6.06071C231.326 6.08108 231.367 6.15239 231.306 6.19313C230.858 6.50892 230.401 6.80434 229.984 7.1405C229.425 7.59891 229.435 8.00638 229.455 8.55646C229.455 8.72964 229.394 8.89263 229.587 9.02505C229.832 9.17786 230.076 9.0658 230.421 9.03524C230.981 8.99449 231.53 9.03524 232.079 9.08617C233.462 9.20841 234.519 9.63626 235.607 10.1456C236.156 10.4105 236.644 10.6855 237.061 11.0217C237.315 11.2254 237.651 11.4699 237.641 11.7347C237.641 11.806 237.488 11.8366 237.407 11.7959C236.502 11.3476 235.617 11.1235 234.468 11.0217C233.431 10.93 232.313 10.9707 231.265 11.0013C230.269 11.0318 229.323 11.1846 228.337 11.256C227.3 11.3273 226.303 11.6023 225.368 11.8773C223.578 12.4071 221.748 12.9775 219.775 13.1813C218.88 13.2729 217.955 13.3239 217.05 13.2424C216.623 13.2016 215.891 13.2118 215.505 13.0386C215.464 13.059 215.403 13.059 215.362 13.0386C215.332 13.0183 215.291 12.9979 215.26 12.9775C215.179 12.9368 215.189 12.8451 215.291 12.8247C216.013 12.6719 216.755 12.8043 217.508 12.784C218.596 12.7534 219.704 12.5191 220.7 12.2441C221.707 11.969 222.734 11.4088 223.385 10.8689C223.781 10.5429 224.056 10.2067 224.066 9.78906C224.086 9.35103 223.853 9.10655 223.334 8.81113C223.243 8.7602 223.273 8.68889 223.365 8.65833C224.015 8.43422 225.093 8.55646 225.713 8.78057C226.059 8.90281 226.273 9.07599 226.466 9.28991C226.629 9.46308 226.649 9.64645 226.74 9.81962C227.127 9.34084 226.059 8.6787 226.008 8.23049C225.957 7.80264 226.405 7.41554 226.913 7.15069H226.883Z",
    fill: "url(#paint11_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.158 6.30578C199.103 6.48914 199.815 7.11054 200.344 7.64025C200.415 7.61987 200.506 7.63006 200.557 7.68099C201.371 8.58761 202.083 9.372 202.154 10.4212C202.215 11.3279 201.737 12.102 200.883 12.8457C200.12 13.4976 198.951 14.0172 197.588 14.0273C196.632 14.0273 195.677 13.7421 194.995 13.3245C194.761 13.243 194.548 13.1411 194.385 13.0392C193.745 12.6318 193.48 11.8779 193.948 11.3584C194.304 10.9611 195.127 10.7981 195.626 11.1751C195.921 11.3992 195.849 11.6436 195.504 11.664C195.849 11.827 196.683 11.8474 196.988 11.8474C197.629 11.8474 198.107 11.7353 198.595 11.4807C199.398 11.063 200.11 10.4009 200.262 9.74891C200.425 9.04602 199.947 8.34313 199.185 7.84398C198.666 7.50782 197.924 6.96792 197.141 6.73362C197.009 7.04941 196.215 7.04942 196.104 6.71325C195.931 6.19373 197.71 6.2141 198.168 6.2956L198.158 6.30578ZM201.777 9.86096C201.696 9.5248 201.513 9.20901 201.289 8.91359C201.422 9.22938 201.472 9.55536 201.422 9.90171C201.218 11.4501 200.14 13.2124 197.405 13.5995C196.958 13.6606 196.429 13.6402 195.921 13.5588C196.541 13.7829 197.263 13.8949 197.985 13.8338C199.449 13.7014 200.435 13.0189 201.117 12.265C201.808 11.4908 201.981 10.737 201.777 9.87115V9.86096Z",
    fill: "url(#paint12_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.503 3.17863C201.503 10.6353 208.621 11.6744 214.986 10.1362C220.965 8.68966 219.857 6.98847 219.297 6.25503C218.738 5.52158 217.243 5.55214 217.569 5.94943C217.894 6.3569 217.274 6.581 217.274 6.581C216.206 7.46725 213.4 6.88661 214.183 5.24654C214.884 3.77965 218.657 3.56572 221.331 4.9715C221.361 4.9715 221.392 4.9715 221.422 4.99187C221.544 5.06318 221.666 5.14467 221.778 5.22616C221.921 5.31785 222.053 5.40953 222.185 5.51139C222.48 5.7355 222.683 5.9698 222.826 6.21428C223.354 6.89679 223.568 7.6608 223.304 8.41462C223.222 8.63873 223.09 8.85265 222.907 9.06657C223.06 9.31106 222.704 9.59628 222.5 9.78983C221.87 10.4112 221.046 10.9409 220.162 11.4197C218.484 12.3263 216.41 12.9885 214.152 13.0802C212.017 13.1718 209.963 12.9375 208.011 12.418C207.024 12.1532 205.957 11.8577 205.082 11.4706C204.655 11.2771 204.33 11.0428 204.055 10.7678C203.72 10.4214 203.394 10.1158 203.008 9.80002C202.926 9.7389 203.018 9.66759 203.12 9.65741C197.609 6.21428 197.497 5.03262 196.093 3.69815C194.568 2.25163 192.697 4.39085 192.697 4.39085C189.677 3.63703 195.504 -4.27808 198.514 3.17863H198.503ZM204.614 10.5233C204.208 10.3094 203.821 10.0954 203.465 9.88151C203.659 10.0241 203.842 10.1667 203.994 10.3399C204.289 10.6659 204.574 10.9919 205.041 11.2364C205.794 11.6234 206.801 11.8985 207.685 12.143C209.475 12.6523 211.346 12.9375 213.318 12.9274C215.413 12.9172 217.192 12.5199 218.911 11.7966C219.826 11.4095 220.65 10.9409 221.372 10.4214C221.534 10.2992 222.266 9.81021 222.541 9.44348C222.338 9.63703 222.124 9.82039 221.911 9.98338C219.816 11.6438 215.84 12.1939 215.596 12.1735C212.444 12.6523 208.438 12.5199 204.604 10.5131L204.614 10.5233Z",
    fill: "url(#paint13_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.303 8.23112C200.456 8.22093 200.608 8.2413 200.75 8.30242C200.75 8.31261 200.771 8.33298 200.791 8.34317C200.862 8.37373 200.934 8.40429 201.005 8.42466C201.391 8.64877 201.696 9.02568 201.869 9.22942C202.215 9.6267 202.591 10.0545 202.601 10.5028C202.621 10.951 202.499 11.4603 202.225 11.8882C202.001 12.2447 201.371 12.6725 200.72 12.754C200.679 12.8355 200.618 12.9068 200.537 12.968C201.432 13.08 202.296 13.0087 202.977 12.6012C203.587 12.2243 203.831 11.6946 203.75 11.1751C203.659 10.5741 203.526 9.88137 202.988 9.35166C202.713 9.07662 202.357 8.84232 201.971 8.6284C201.757 8.50616 201.523 8.42466 201.3 8.34317C201.025 8.14962 200.69 8.00701 200.273 8.04775C200.079 8.06813 200.11 8.25149 200.313 8.2413L200.303 8.23112Z",
    fill: "url(#paint14_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.198 10.1761C198.198 10.1761 198.269 10.1558 198.3 10.1558C198.432 10.1252 198.575 10.1252 198.717 10.1761C198.788 10.2067 198.859 10.2678 198.778 10.3187C198.432 10.4817 198.595 10.6549 199.266 10.8383C199.581 10.716 199.795 10.553 199.917 10.3493C200.049 10.1761 200.12 9.99277 200.212 9.81959C200.273 9.70754 200.547 9.77884 200.486 9.8909C200.242 10.3595 199.947 11.1235 198.89 11.0827C198.208 11.0522 198.107 10.6243 198.381 10.3391C198.351 10.3595 198.31 10.3799 198.28 10.4002C197.975 10.6345 198.188 11.0216 198.442 11.2763C198.544 11.3578 198.636 11.4393 198.747 11.5208C198.798 11.5615 198.91 11.6023 198.93 11.6634C199.042 11.969 198.239 11.9486 198.025 11.7856C197.985 11.7551 197.985 11.7245 198.005 11.7041C197.507 11.368 197.222 11.0114 197.598 10.5734C197.71 10.4512 197.924 10.2882 198.168 10.2067C198.168 10.2067 198.188 10.1965 198.198 10.1965V10.1761Z",
    fill: "url(#paint15_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.038 11.6248C229.038 11.6248 234.794 10.9423 236.695 12.3277C238.596 13.7131 237.163 14.1613 236.726 13.8048C236.288 13.4483 234.692 11.4313 229.049 11.6147L229.038 11.6248Z",
    fill: "url(#paint16_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.721 0.844951C192.901 0.844951 191.426 1.75157 191.426 2.86193C191.426 3.97229 192.901 4.87891 194.721 4.87891C196.541 4.87891 198.015 3.97229 198.015 2.86193C198.015 1.75157 196.541 0.844951 194.721 0.844951Z",
    fill: "url(#paint17_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.458 10.8899C185.458 10.8899 175.035 17.2159 164.613 13.457C164.613 13.457 175.035 19.2329 185.458 10.8899Z",
    fill: "url(#paint18_linear_542_6813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.831 10.5325C203.831 10.5325 214.254 16.8585 224.676 13.0995C224.676 13.0995 214.254 18.8754 203.831 10.5325Z",
    fill: "url(#paint19_linear_542_6813)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_542_6813",
    x1: 0,
    y1: 8.29265,
    x2: 160.627,
    y2: 8.29265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_542_6813",
    x1: 228.194,
    y1: 8.28265,
    x2: 396,
    y2: 8.28265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_542_6813",
    x1: 188.244,
    y1: 18.8761,
    x2: 201.045,
    y2: 18.8761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_542_6813",
    x1: 153.092,
    y1: 15.8204,
    x2: 162.64,
    y2: 15.8204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_542_6813",
    x1: 152.045,
    y1: 9.65703,
    x2: 174.496,
    y2: 9.65703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_542_6813",
    x1: 187.522,
    y1: 10.1455,
    x2: 195.971,
    y2: 10.1455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_542_6813",
    x1: 166.27,
    y1: 6.54891,
    x2: 197.832,
    y2: 6.54891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_542_6813",
    x1: 185.905,
    y1: 10.5333,
    x2: 189.545,
    y2: 10.5333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_542_6813",
    x1: 189.179,
    y1: 10.8182,
    x2: 192.25,
    y2: 10.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_542_6813",
    x1: 152.035,
    y1: 12.6925,
    x2: 160.637,
    y2: 12.6925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_542_6813",
    x1: 227.045,
    y1: 15.8209,
    x2: 236.593,
    y2: 15.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_542_6813",
    x1: 215.179,
    y1: 9.65663,
    x2: 237.641,
    y2: 9.65663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_542_6813",
    x1: 193.704,
    y1: 10.1462,
    x2: 202.154,
    y2: 10.1462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_542_6813",
    x1: 191.853,
    y1: 6.55044,
    x2: 223.415,
    y2: 6.55044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_542_6813",
    x1: 200.14,
    y1: 10.5333,
    x2: 203.77,
    y2: 10.5333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_542_6813",
    x1: 197.426,
    y1: 10.8179,
    x2: 200.496,
    y2: 10.8179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_542_6813",
    x1: 229.038,
    y1: 12.6945,
    x2: 237.651,
    y2: 12.6945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_542_6813",
    x1: 191.426,
    y1: 2.86193,
    x2: 198.025,
    y2: 2.86193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_542_6813",
    x1: 164.603,
    y1: 13.1514,
    x2: 185.458,
    y2: 13.1514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_542_6813",
    x1: 203.831,
    y1: 12.7838,
    x2: 224.676,
    y2: 12.7838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_6813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletDivider);
export default __webpack_public_path__ + "static/media/icon_wallet_divider.fd9677dade7873f109c2c60e25f3cf56.svg";
export { ForwardRef as ReactComponent };